/* eslint-disable @typescript-eslint/no-explicit-any */
import ReactECharts from 'echarts-for-react';
// 1. 按需引入 ECharts 核心模块（仅引入需要的部分）
import { registerMap } from 'echarts/core';
// 2. 按需引入地图相关模块（仅地图图表+必要组件+渲染器）
import { MapChart } from 'echarts/charts';
import { TitleComponent, TooltipComponent, VisualMapComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
// 3. 仅引入世界地图 GeoJSON 数据（核心：不引入其他地图）

import worldGeoJson from './world.json';
// 4. 引入 echarts-for-react 所需的 ECharts 核心入口（用于绑定模块）
import * as echarts from 'echarts/core';
import { EChartsOption } from 'echarts';

// 注册仅需的模块（体积优化关键：只注册地图相关模块）
echarts.use([MapChart, TitleComponent, TooltipComponent, VisualMapComponent, CanvasRenderer]);

// 注册世界地图（仅注册一次，避免重复注册）

registerMap('world', worldGeoJson as any);
interface BuyersMapComponentProps {
  mapData: { name: string; value: number }[];
}

// 封装世界地图组件
export const BuyersMapComponent = ({ mapData = [] }: BuyersMapComponentProps) => {
  // 世界地图核心配置项
  const getMapOption = () =>
    ({
      roam: false,
      geo: {
        map: 'world',
        roam: false,
        itemStyle: {
          areaColor: '#ebedf2',
          borderWidth: 0,
        },
      },
      visualMap: {
        // min: 800,
        // max: 50000,
        show: false,
        text: ['High', 'Low'],
        realtime: false,
        calculable: true,
        inRange: {
          color: ['#e8f4f8', '#4299e1', '#2563eb'], // 浅蓝色→深蓝色渐变,
        },
      },
      title: {
        left: 'center',
        show: false,
        textStyle: { fontSize: 16 },
      },
      // 悬浮提示：显示国家名称+数值
      tooltip: {
        trigger: 'item',
        formatter: (params: any) => {
          return `${params.name}: ${params.value || 0}`;
        },
      },

      // 地图核心配置
      series: [
        {
          name: '数据指标',
          type: 'map',
          mapType: 'world', // 对应注册的世界地图
          roam: false, // 允许鼠标缩放/拖拽地图
          label: {
            show: false, // 默认不显示国家名称
            fontSize: 10,
            color: '#333',
          },
          emphasis: {
            // 鼠标悬浮时的样式
            label: { color: '#fff' },
            itemStyle: { areaColor: '#1890ff' },
          },
          itemStyle: {
            areaColor: '#f5f5f5', // 地图区域底色（可选，增强边框对比）
            borderColor: 'transparent', // 边框颜色（黑色，对比明显）
            borderWidth: 0, // 边框宽度（1px，可调整）
            borderType: 'solid', // 边框样式（实线，可选 dashed/dotted）
          },
          data: mapData, // 绑定业务数据
        } as any,
      ],
    }) satisfies EChartsOption;

  return (
    // echarts-for-react 核心组件
    <ReactECharts
      // 传入按需注册后的 echarts 实例（关键：避免使用全量 echarts）
      echarts={echarts}
      // 地图配置项
      option={getMapOption()}
      // 容器样式（必须指定宽高，支持响应式）
      style={{ width: '515px' }}
      // 自动响应窗口resize（无需手动写监听）
      // 可选：延迟渲染（避免首屏卡顿）
      lazyUpdate={true}
    />
  );
};
